import { Table, TableProps } from "rsuite";
import { PropsWithChildren } from "react";
import { HeaderCellProps } from "rsuite-table";

type RegplusTableProps = {
  paginated?: boolean;
} & TableProps;

const { HeaderCell } = Table;

export const EditableTable = ({ children, ...props }: PropsWithChildren<RegplusTableProps>) => {
  return (
    <Table virtualized height={props.height} {...props}>
      {children}
    </Table>
  );
};

export const RegAuthHeaderCell = (props: HeaderCellProps) => <HeaderCell {...props} className="admin-list-table-header-cell" />;
